'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
export default (function (_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx("div", {
    className: "subtitle",
    children: children
  });
});